<div [@routerTransition] class="margin-top-18px">
  
  <div class="card my-profile-form margin-top-10" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-7">
          Session
        </div>
      
        <div class="col-md-5">
          <div class="row">
            <div class="col-md-6">
              <input type="text" class="form-control" placeholder="Search">
            </div>
            <div class="col-md-2 padding-left-10px">
              <a (click)="AddNewSession()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Session"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Add</a>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="font-weight-normal">
                      Session
                    </th>
                  
                    <th class="font-weight-normal">
                      From Time
                    </th>
                    <th class="font-weight-normal">
                      To Time
                    </th>
                    
                    <th class="font-weight-normal">
                      Duration
                    </th>

                    <th class="font-weight-normal">
                      Total Slots
                    </th>

                    <th class="">
                      
                    </th>
                  

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr>

                    <td class="td-padding-tb">Morning</td>

                    <td class="td-padding-tb"></td>
                    <td class=" td-padding-tb"> </td>

                    <td class=" td-padding-tb"> </td>
                    <td class=" td-padding-tb "> </td>

                    <td class="td-padding-tb"><a (click)="EditSession()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a> <i class="fas fa-times margin-left-5px color-Rejected"></i> </td>


                  </tr>

                  <tr>

                    <td class="td-padding-tb">Afternoon</td>

                    <td class="td-padding-tb"></td>
                    <td class=" td-padding-tb"> </td>

                    <td class=" td-padding-tb"> </td>
                    <td class=" td-padding-tb "> </td>

                    <td class="td-padding-tb"><a (click)="EditSession()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a> <i class="fas fa-times margin-left-5px color-Rejected"></i> </td>


                  </tr>

                  <tr>

                    <td class="td-padding-tb">Evening</td>

                    <td class="td-padding-tb"></td>
                    <td class=" td-padding-tb"> </td>

                    <td class=" td-padding-tb"> </td>
                    <td class=" td-padding-tb "> </td>

                    <td class="td-padding-tb"><a (click)="EditSession()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a> <i class="fas fa-times margin-left-5px color-Rejected"></i> </td>


                  </tr>

                  <tr>

                    <td class="td-padding-tb">Night</td>

                    <td class="td-padding-tb"></td>
                    <td class=" td-padding-tb"> </td>

                    <td class=" td-padding-tb"> </td>
                    <td class=" td-padding-tb "> </td>

                    <td class="td-padding-tb"><a (click)="EditSession()"><i class="fas fa-pencil-alt margin-right-10px nav-link-hand color-Assign"></i></a> <i class="fas fa-times margin-left-5px color-Rejected"></i> </td>


                  </tr>

                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

